module.exports = __webpack_public_path__ + "img/picture_25-1.13ea64c0.png";